import React from "react";
import CountUp from "react-countup";
import { ArrowUpIcon, ArrowDownIcon } from "@heroicons/react/24/outline";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const PayrollStats = ({ stats }) => (
  <div className="w-full grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
    {stats.map((stat) => (
      <div
        key={stat.name}
        className="border border-gray-200 bg-white px-3 py-2.5 group rounded-sm">
        <div className="flex items-baseline justify-between gap-2">
          <p className="text-xs font-medium text-gray-500 truncate">
            {stat.name} {stat.extra}
          </p>
          {stat.change && (
            <div
              className={classNames(
                "flex items-center text-xs font-medium gap-0.5 transition-colors",
                stat.changeType === "negative" 
                  ? "text-red-600 group-hover:text-red-700" 
                  : "text-emerald-600 group-hover:text-emerald-700"
              )}>
              {stat.changeType === "negative" ? (
                <ArrowDownIcon className="h-3 w-3" />
              ) : (
                <ArrowUpIcon className="h-3 w-3" />
              )}
              {stat.change}
            </div>
          )}
        </div>
        <div className="mt-1">
          <span className={classNames(
            "text-lg font-semibold tabular-nums",
            stat.changeType === "negative" ? "text-gray-900" : "text-gray-900"
          )}>
            {[
              "Pending Appointments",
              "Completed Appointments",
              "Carryover Appointments",
              "Estimated Pay",
              "Total Pending Pay",
              "Total Completed Pay",
              "Total Carryover Pay",
            ].includes(stat.name) ? (
              stat.name.includes("Pay") ? (
                <CountUp
                  start={0}
                  end={parseFloat(stat.value.replace(/[^0-9.-]+/g, ""))}
                  duration={1.5}
                  decimals={2}
                  prefix="$"
                />
              ) : (
                <CountUp
                  start={0}
                  end={parseInt(stat.value, 10)}
                  duration={1.5}
                />
              )
            ) : (
              stat.value
            )}
          </span>
        </div>
      </div>
    ))}
  </div>
);

export default PayrollStats;
